import { useLocalStorageState } from '../../hooks/useLocalStorage';

const COFFEE_SHELL_V2_KEY = 'coffee-shell-v2';

/**
 * Client-only, unlike the Focused View opt-in. That one is server-backed so the API can stamp
 * `uiVersion` onto inbound calls; no backend consumer needs to know which chrome a rep is looking at.
 *
 * Internal dogfooding only — clearing storage silently reverts. Opening this to customers means
 * revisiting the decision and adding a preference field.
 */
export function useCoffeeShellV2(): [boolean, (next: boolean) => void] {
	return useLocalStorageState<boolean>(COFFEE_SHELL_V2_KEY, false);
}

/**
 * Whether to surface the in-app toggle. Set in `.env.development` and `.env.pr-test` only — notably not
 * `.env.production`, which `dev:prod` also loads, so there is no way to enable it locally against prod
 * without shipping it.
 *
 * This gates discovery, not capability: the flag is read straight from `localStorage`, so setting
 * `coffee-shell-v2` by hand still works in any environment.
 */
export const isCoffeeShellToggleVisible = () => import.meta.env.VITE_COFFEE_SHELL_V2_TOGGLE === 'true';
